import { type FC, memo, useContext } from 'react';
import { useFragment, graphql } from 'react-relay';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton';
import { NftPdpBidModalContent } from './NftPdpBidModalContent';
import { NftPdpBidModalContext } from './NftPdpBidModalContext';
import { type NftPdpBidModal_nftItem$key } from './__generated__/NftPdpBidModal_nftItem.graphql';
import { type NftPdpBidModal_viewer$key } from './__generated__/NftPdpBidModal_viewer.graphql';

type Props = {
    nftItem: NftPdpBidModal_nftItem$key;
    viewer: NftPdpBidModal_viewer$key;
};

export const NftPdpBidModal: FC<Props> = memo(({ nftItem: nftItemRef, viewer: viewerRef }) => {
    const { modalOpen, closeModal } = useContext(NftPdpBidModalContext);
    const nftItem = useFragment(
        graphql`
            fragment NftPdpBidModal_nftItem on NftItem {
                ...NftPdpBidModalContent_nftItem
            }
        `,
        nftItemRef
    );
    const viewer = useFragment(
        graphql`
            fragment NftPdpBidModal_viewer on Viewer {
                ...NftPdpBidModalContent_viewer
            }
        `,
        viewerRef
    );
    return (
        <ModalContainer isOpen={modalOpen} onClose={closeModal}>
            <ModalCloseButton onClick={closeModal} />
            <NftPdpBidModalContent nftItem={nftItem} viewer={viewer} />
        </ModalContainer>
    );
});
